import { useEffect, useState } from 'react';
import { yesterday, lastMonth } from 'components/DateRangePicker/utils';
import { toApiDayFormat } from 'utils/date';
import useHistory from 'data/hooks/useHistory';
import { useDebounce } from 'use-debounce';

const useConnect = () => {
  const [from, setFrom] = useState<Date>(lastMonth);
  const [to, setTo] = useState<Date>(yesterday);
  const [selectedBrandId, setSelectedBrandId] =
    useState<string>('all-restaurants');
  const [search, setSearch] = useState<string | undefined>(undefined);
  const [devouncedSearch] = useDebounce(search, 300);
  const {
    orders,
    isFetching,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    refetch,
  } = useHistory({
    dateStart: toApiDayFormat(from),
    dateEnd: toApiDayFormat(to),
    brandId:
      selectedBrandId !== 'all-restaurants' ? selectedBrandId : undefined,
    search,
  });

  useEffect(() => {
    refetch();
  }, [refetch, from, to, selectedBrandId, devouncedSearch]);

  return {
    search,
    setSearch,
    setSelectedBrandId,
    selectedBrandId,
    from,
    setFrom,
    to,
    setTo,
    orders,
    isFetching,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
  };
};

export default useConnect;
